import React from 'react';
import { Policies } from '../../../Policies';
import { QuoteSearch } from '../../../QuoteSearch';
import { Admin } from '../../../Admin';
import { NavigationItem } from '../../types';
import { RouteComponentProps } from 'react-router';
import { viewAdminPortalPolicy } from '../../authPolicies';
import { CurrentUserData } from 'Auth/components/AuthProvider/AuthProvider';
import { RewardsEnrollmentProviderType } from 'Shared/hooks';
import { Rewards } from 'Rewards/components';
import { hasScopedPermission } from 'Shared/utils';
import { BoltIcon } from '@clearcover/atlas';
import { Tools } from 'Tools';

const agentServicesRoute = {
  name: 'Admin',
  path: '/admin',
  component: Admin,
  assetVariant: 'people',
  testId: 'primary-menu-admin-link',
} as const;

const navItems = [
  {
    name: 'Quotes',
    path: '/quotes',
    component: QuoteSearch,
    assetVariant: 'page',
    testId: 'primary-menu-quotes-link',
  } as const,
  {
    name: 'Policies',
    path: '/policies',
    assetVariant: 'shield',
    component: Policies,
    testId: 'primary-menu-policies-link',
  } as const,
];

const rewardsRoute = {
  name: 'Rewards Portal',
  path: '/rewards',
  assetVariant: 'gift',
  component: Rewards,
  testId: 'primary-menu-rewards-link',
} as const;

const toolsRoute = {
  name: 'Tools',
  path: '/tools',
  component: Tools,
  icon: BoltIcon,
  testId: 'primary-menu-tools-link',
} as const;

type NavigationManifestType = Array<
  NavigationItem & {
    component: React.FunctionComponent<RouteComponentProps>;
  }
>;

export const getRoutes: ({
  user,
  rewardsEnrollment,
}: {
  user: CurrentUserData['currentUser'];
  rewardsEnrollment?: RewardsEnrollmentProviderType;
}) => NavigationManifestType = ({ user, rewardsEnrollment }) => {
  const canViewAdminPortal = viewAdminPortalPolicy(user.effectiveGrants);
  const canViewRewards =
    rewardsEnrollment &&
    !rewardsEnrollment.rewardsEnrollmentLoading &&
    rewardsEnrollment.rewardsEnrollmentResponse?.isEnrolled;

  const hasStateConfigurationsAccess = hasScopedPermission(
    user.effectiveGrants,
    'partner',
    'state_configurations.read'
  );
  const hasMoratoriumsAccess = hasScopedPermission(
    user.effectiveGrants,
    'partner',
    'moratoriums.read'
  );
  const canViewTools = hasStateConfigurationsAccess || hasMoratoriumsAccess;

  return [
    ...navItems,
    ...(canViewAdminPortal ? [agentServicesRoute] : []),
    ...(canViewRewards ? [rewardsRoute] : []),
    ...(canViewTools ? [toolsRoute] : []),
  ];
};
